<template>
  <div>
    <div
      v-if="user && !user.memberType === 'free'"
      class="section-label"
      @click="$store.commit('showReferProgram')"
    >
      <div class="section-icon-container">
        <i class="material-icons section-iconm help-icon"
          >sentiment_satisfied_alt</i
        >
      </div>
      &nbsp;Refer & Earn
    </div>
    <div class="clearfix"></div>
    <div class="section-label" @click="clickSettings">
      <div class="section-icon-container">
        <i class="material-icons section-icon settings-icon">settings</i>
      </div>
      &nbsp;Account Settings
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsSection",
  props: ["user"],
  methods: {
    clickHelp() {
      window.Intercom("show");
    },
    clickSettings() {
      window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/settings";
    },
  },
};
</script>

<style lang="scss" scoped>
.section-container {
  margin-bottom: 20px;
  border-bottom: 0px solid #e7e7eb;
  padding-bottom: 20px;
}
.section-icon {
  display: inline-block;
  font-size: 16pt;
  color: #666;
}
.help-icon {
  font-size: 17pt;
}
.settings-icon {
  margin-left: 2px;
}
.section-icon-container {
  float: left;
  margin-top: 2px;
  width: 26px;
}
.section-label {
  margin-top: 8px;
  margin-left: 18px;
  padding: 0 0 0.05em 2px;
  font-weight: 600;
  font-size: 13pt !important;
  font-family: "Source Sans Pro";
  color: #666;
}
.section-label:hover {
  opacity: 0.7;
  cursor: pointer;
}
</style>